import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
  MetaReducer
} from '@ngrx/store';
import { environment } from '../../environments/environment';
import {titleReducer, TitlesState} from "./titles.reducer";
import {fleetUserReducer, FleetUserState} from "./fleet-user.reducer";
import {userReducer, UserState} from "./user.reducer";
import {fleetReducer, FleetState} from "./fleet.reducer";

export interface State {
  titles: TitlesState,
  // user: UserState,
  // fleet: FleetState,
  fleetAndUser: FleetUserState
}

export const reducers: ActionReducerMap<State> = {
  titles: titleReducer,
  // user: userReducer,
  // fleet: fleetReducer,
  fleetAndUser: fleetUserReducer
};


export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];

// export const selectUserState = (state:State) => state.user;
// export const selectFleetState = (state:State) => state.fleet;
export const selectFleetUserState = (state:State) => state.fleetAndUser;
// export const selectFleetUserState = (state:State) => state.fleetAndUser;
//
export const selectFleet = createSelector(selectFleetUserState,
  (state:FleetUserState) => state.fleet);

export const selectUser = createSelector(selectFleetUserState,
  (state:FleetUserState) => state.user);



